var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IncentivesExportValidationState_1;
import { DateConverter, JSON, JsonConverter, JsonSchema } from '@symon-ai/wisepipe-serialize';
const schema = {
    $id: 'urn:wisepipe-common-pipe:IncentivesExportValidationState',
    type: 'object',
    properties: {
        pipeID: { type: 'string', uid: 10 },
        elementID: { type: 'string', uid: 10 },
        isValid: { type: 'boolean' },
        insMatchConfig: { type: 'boolean' },
        lastValidated: { type: 'string', format: 'date-time' }
    },
    required: ['pipeID', 'elementID', 'isValid', 'lastValidated']
};
let IncentivesExportValidationState = IncentivesExportValidationState_1 = class IncentivesExportValidationState {
    constructor(pipeID, elementID, isValid, lastValidated, insMatchConfig) {
        this.pipeID = pipeID;
        this.elementID = elementID;
        this.isValid = isValid;
        this.lastValidated = lastValidated;
        if (insMatchConfig !== undefined) {
            this.insMatchConfig = insMatchConfig;
        }
        JSON.validate(this, IncentivesExportValidationState_1);
    }
};
__decorate([
    JsonConverter(new DateConverter('date-time'))
], IncentivesExportValidationState.prototype, "lastValidated", void 0);
IncentivesExportValidationState = IncentivesExportValidationState_1 = __decorate([
    JsonSchema(schema)
], IncentivesExportValidationState);
export { IncentivesExportValidationState };
//# sourceMappingURL=incentivesExportValidationState.js.map